import { defineStore } from "pinia";
const useProductMessagesStore = defineStore("productMessagesStore", {
  state: () => ({
    messages: {
      freeShipping: null,
      promo: {
        priceOffer: null,
        memberFirst: null
      },
      prop65: null,
      shippingRestrictions: null,
      shipUrgency: null
    }
  }),
  getters: {},
  actions: {}
});
export {
  useProductMessagesStore as default
};
//# sourceMappingURL=productMessagesStore.mjs.map
